import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const profileSchema = itemSchema.extend({
  network: z.string(),
  username: z.string(),
  icon: z
    .string()
    .describe(
      'Slug for the icon from https://simpleicons.org. For example, "github", "linkedin", etc.',
    ),
  url: urlSchema,
});

export const minimalProfileSchema = profileSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Profile = z.infer<typeof profileSchema>;
export type MinimalProfile = z.infer<typeof minimalProfileSchema>;

// Defaults
export const defaultProfile: Profile = {
  ...defaultItem,
  network: "",
  username: "",
  icon: "",
  url: defaultUrl,
};

export const deminimalizeProfile = (profile: MinimalProfile): Profile => {
  return {
    ...defaultProfile,
    ...profile,
    id: createId(),
  };
};
